import Vue from 'vue'
import Vuex from 'vuex'
import mutations from './mutations.js'
import actions from './action.js'
import getters from './getter'

Vue.use(Vuex)

const state = {
  isURSLogin: true,
  username: '宝贝',
  orderId: '',
  userAddress: {
    id: 3,
    userId: 1083,
    consigneeName: null,
    mobile: null,
    provinceCode: null,
    cityCode: null,
    districtCode: null,
    provinceName: null,
    cityName: null,
    districtName: null,
    street: null,
    status: 1,
    createTime: 1557222941000,
    updateTime: 1557458558000
  }
}
export default new Vuex.Store({
  state,
  getters,
  actions,
  mutations
})
